module.exports = __webpack_public_path__ + "media/images/9-3498c20e.png";